export default __webpack_public_path__ + "static/dan-about-pic-522045eb516cbae0f80d51cdf6b00fe9.jpg";